interface Filling {
  image: string;
  artNo: string;
}

export const fillingMap: { [key: string]: { [key: string]: Filling } } = {
  melamin: {
    white: { image: '40002-White_Melamine_BH', artNo: '40002' },
    'soft white': { image: '40008-SoftWhite_Melamine_BH', artNo: '40008' }
  },
  'melamin exklusiv': {
    'kritvit melamin': { image: '40122-SatinWhite_MelamineE_BH', artNo: '40122' },
    'betonggrå melamin': { image: '40100-StonewareGrey-MelamineE_BH', artNo: '40100' },
    'natural clay': { image: '40102-NaturalClay_MelamineE_BH', artNo: '40102' }
  },
  'dekor special': {
    'glossy white': { image: '50056-GlossyWhite_Dekorspecial_BH', artNo: '40056' },
    'blueberry milk': { image: '40114-BlueberryMilk_Dekorspecial_BH', artNo: '40114' },
    tarragon: { image: '40110-Tarragon_Dekorspecial_BH', artNo: '40110' },
    'autumn chestnut': { image: '40118-AutumnChestnut_Dekorspecial_BH', artNo: '40118' }
  },
  spegel: {
    'klar spegel': { image: '30001-Clear-mirror_BH', artNo: '30001' },
    'grå spegel': { image: '30003-Grey-mirror_BH', artNo: '30003' },
    'brons spegel': { image: '30002-Bronze-mirror_BH', artNo: '3002' }
  },
  glas: {
    'vitt glas': { image: '50022-CrispyWhite_Glass_BH', artNo: '50022' },
    'svart glas': { image: '50006-LovelyLiquorice_Glass_BH', artNo: '50006' }
  },
  'glas exklusiv': {
    'frostat vitt glas': { image: '50056-FrostingWhite_GlassE_BH', artNo: '50056' },
    'wintry hazel': { image: '50054-WintryHazel_GlassE_BH', artNo: '50054' },
    'snow cloud': { image: '50050-SnowCloud_GlassE_BH', artNo: '50050' },
    'arctic night': { image: '50062-ArticNight_GlassE_BH', artNo: '50062' },
    'frostat svart glas': { image: '50058-IcedEbony_GlassE_BH', artNo: '50058' },
    'klart härdat glas': { image: '', artNo: '50040' },
    'frostat härdat glas': { image: '', artNo: '50020' },
    'grey hardened glass': { image: '', artNo: '50042' },
    'bronze hardened glass': { image: '', artNo: '50041' },
    'soothing sage': { image: '50064-SoothingSage_GlassE_BH', artNo: '50064' },
    'morning dew': { image: '50066-MorningDew_GlassE_BH', artNo: '50066' },
    'misty grey': { image: '50068-MistyGrey_GlassE_BH', artNo: '50068' },
    'cosy cashmere': { image: '50070-CosyCashmere_GlassE_BH', artNo: '50070' }
  },
  trämelamin: {
    'vit ek melamin': { image: '40006-RimeFrostOak_WMelamine_BH', artNo: '40006' },
    'ek melamin': { image: '40004-SensibleOak_WMelamine_BH', artNo: '40004' },
    'svart ek melamin': { image: '40062-Charcoaloak_Tramelamin_BH', artNo: '40062' },
    'ljus ek melamin': { image: '40082-LightOak_WMelamine_BH', artNo: '40082' },
    'mörk ek melamin': { image: '40084-DarkOak_WMelamine_BH', artNo: '40084' }
  },
  träfanér: {
    'truly oak veneer': { image: '', artNo: '80012' },
    'genuine walnut veneer': { image: '', artNo: '80008' }
  },
  select: {
    '': { image: '', artNo: '' }
  },
  'select exklusiv': {
    '': { image: '', artNo: '' }
  },
  // --- Norway ---
  'melamin eksklusiv': {
    'kritthvit melamin': { image: '40122-SatinWhite_MelamineE_BH', artNo: '40122' },
    'betonggrå melamin': { image: '40100-StonewareGrey-MelamineE_BH', artNo: '40100' },
    'natural clay': { image: '40102-NaturalClay_MelamineE_BH', artNo: '40102' }
  },
  'dekor spesial': {
    'glossy white': { image: '50056-GlossyWhite_Dekorspecial_BH', artNo: '40056' },
    'blueberry milk': { image: '40114-BlueberryMilk_Dekorspecial_BH', artNo: '40114' },
    tarragon: { image: '40110-Tarragon_Dekorspecial_BH', artNo: '40110' },
    'autumn chestnut': { image: '40118-AutumnChestnut_Dekorspecial_BH', artNo: '40118' }
  },
  speil: {
    'klart speil': { image: '30001-Clear-mirror_BH', artNo: '30001' },
    'gråtonet speil': { image: '30003-Grey-mirror_BH', artNo: '30003' },
    'bronsetonet speil': { image: '30002-Bronze-mirror_BH', artNo: '3002' }
  },
  glass: {
    'hvitt glass': { image: '50022-CrispyWhite_Glass_BH', artNo: '50022' },
    'shiny grey': { image: '50004-ShinyGrey_Glass_BH', artNo: '50004' },
    'sort glass': { image: '50006-LovelyLiquorice_Glass_BH', artNo: '50006' }
  },
  'glass eksklusiv': {
    'matt hvitt glass': { image: '50056-FrostingWhite_GlassE_BH', artNo: '50056' },
    'wintry hazel': { image: '50054-WintryHazel_GlassE_BH', artNo: '50054' },
    'snow cloud': { image: '50050-SnowCloud_GlassE_BH', artNo: '50050' },
    'arctic night': { image: '50062-ArticNight_GlassE_BH', artNo: '50062' },
    'matt sort glass': { image: '50058-IcedEbony_GlassE_BH', artNo: '50058' },
    'klart herdet glass': { image: '', artNo: '50040' },
    'frostet herdet glass': { image: '', artNo: '50020' },
    'grey hardened glass': { image: '', artNo: '50042' },
    'bronze hardened glass': { image: '', artNo: '50041' },
    'soothing sage': { image: '50064-SoothingSage_GlassE_BH', artNo: '50064' },
    'morning dew': { image: '50066-MorningDew_GlassE_BH', artNo: '50066' },
    'misty grey': { image: '50068-MistyGrey_GlassE_BH', artNo: '50068' },
    'cosy cashmere': { image: '50070-CosyCashmere_GlassE_BH', artNo: '50070' }
  },
  tremelamin: {
    'hvit eik melamin': { image: '40006-RimeFrostOak_WMelamine_BH', artNo: '40006' },
    'eik melamin': { image: '40004-SensibleOak_WMelamine_BH', artNo: '40004' },
    'sort eik melamin': { image: '40062-Charcoaloak_Tramelamin_BH', artNo: '40062' },
    'lys eik melamin': { image: '40082-LightOak_WMelamine_BH', artNo: '40082' },
    'mørk eik melamin': { image: '40084-DarkOak_WMelamine_BH', artNo: '40084' }
  },
  trefiner: {
    'truly oak veneer': { image: '', artNo: '80012' },
    'genuine walnut veneer': { image: '', artNo: '80008' }
  },
  'select eksklusiv': {
    '': { image: '', artNo: '' }
  }
};
